import { Suspense } from "react";
import Header from "@/components/layout/Header";
import Hero from "@/components/sections/Hero";
import Seo from "@/components/Seo";
import { lazyWithRetry } from "@/lib/lazyWithRetry";

const Footer = lazyWithRetry(() => import("@/components/layout/Footer"));
const CookieConsent = lazyWithRetry(() => import("@/components/CookieConsent"));

const Problem = lazyWithRetry(() => import("@/components/sections/Problem"));
const Solution = lazyWithRetry(() => import("@/components/sections/Solution"));
const InstitutionTypes = lazyWithRetry(() => import("@/components/sections/InstitutionTypes"));
const Benefits = lazyWithRetry(() => import("@/components/sections/Benefits"));
const ContactForm = lazyWithRetry(() => import("@/components/sections/ContactForm"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background" dir="rtl">
      <Seo
        title="CARETEX - מערכת ניהול מוסדות סיעודיים וגריאטריים"
        description="CARETEX היא מערכת ניהול חכמה לבתי אבות, דיור מוגן ומרכזי שיקום: ניהול מטופלים, תורים, דוחות ובקרה במקום אחד."
        path="/"
      />
      <Header />
      <main>
        <Hero />
        <Suspense fallback={<div className="min-h-[200px]" />}>
          <Problem />
          <Solution />
          <InstitutionTypes />
          <Benefits />
          <ContactForm />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <CookieConsent />
      </Suspense>
    </div>
  );
};

export default Index;
